import { render } from "./UserSettingsLayout.vue?vue&type=template&id=7d1d3bfc&scoped=true"
import script from "./UserSettingsLayout.vue?vue&type=script&lang=js"
export * from "./UserSettingsLayout.vue?vue&type=script&lang=js"

import "./UserSettingsLayout.vue?vue&type=style&index=0&id=7d1d3bfc&lang=scss"
import "./UserSettingsLayout.vue?vue&type=style&index=1&id=7d1d3bfc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7d1d3bfc"

export default script